import { withAppCrashIfException } from 'epic';
import { cancelLimitOrderTradeEpic } from 'epic/secondaryMarket/limit-order/cancelLimitOrderEpic';
import { fetchLimitOrderInteractionClientEpic } from 'epic/secondaryMarket/limit-order/fetchLimitOrderInteractionClientEpic';
import { fetchLimitOrderInteractionCustodianEpic } from 'epic/secondaryMarket/limit-order/fetchLimitOrderInteractionCustodianEpic';
import { fetchLimitOrderSettlementDateEpic } from 'epic/secondaryMarket/limit-order/fetchLimitOrderSettlementDateEpic';
import { initLimitOrderFormEpic } from 'epic/secondaryMarket/limit-order/initLimitOrderFormEpic';
import {
  subscribeLimitOrderStreamingEpic,
  unsubscribeLimitOrderStreamingEpic,
} from 'epic/secondaryMarket/limit-order/limitOrderRealtimeEpic';
import { reloadLimitOrderTabContentEpic } from 'epic/secondaryMarket/limit-order/reloadLimitOrderFormEpic';
import { combineEpics } from 'redux-observable';
import { limitOrderSelectors } from 'state/secondaryMarket/limit-order/limitOrder.selector';
import { liveSelectors } from 'state/secondaryMarket/live/live.selector';

import { amendLimitOrderTradeEpic } from './amendLimitOrderEpic';
import { limitOrderPlacementRequestEpic } from './limitOrderPlacementRequestEpic';

export const secondaryMarketLimitOrderEpic = () =>
  combineEpics(
    withAppCrashIfException('cancelLimitOrderTradeEpic', cancelLimitOrderTradeEpic()),
    withAppCrashIfException('fetchLimitOrderInteractionClientEpic', fetchLimitOrderInteractionClientEpic()),
    withAppCrashIfException('fetchLimitOrderInteractionCustodianEpic', fetchLimitOrderInteractionCustodianEpic()),
    withAppCrashIfException('fetchLimitOrderSettlementDateEpic', fetchLimitOrderSettlementDateEpic()),
    withAppCrashIfException('initLimitOrderFormEpic', initLimitOrderFormEpic()),
    withAppCrashIfException('limitOrderPlacementRequestEpic', limitOrderPlacementRequestEpic()),
    withAppCrashIfException('reloadLimitOrderTabContentEpic', reloadLimitOrderTabContentEpic()),
    withAppCrashIfException('amendLimitOrderTradeEpic', amendLimitOrderTradeEpic()),
    withAppCrashIfException('subscribeLimitOrderStreamingEpic', subscribeLimitOrderStreamingEpic()),
    withAppCrashIfException(
      'unsubscribeLimitOrderStreamingEpic',
      unsubscribeLimitOrderStreamingEpic(
        liveSelectors.getKeepAliveProductIds,
        limitOrderSelectors.getKeepAliveProductIds,
      ),
    ),
  );
